export enum FlightSchedulingMixPanelEvents {
  OrderFlightWindowRequested = 'order.flight_window_requested',
  OrderFlightWindowSubmitted = 'order.flight_window_submited',
  OrderFlightWindowApproved = 'order.flight_window_approved',
  OrderFlightDateRequested = 'order.flight_date_requested',
  OrderFlightDateSubmitted = 'order.flight_date_submited',
  OrderFlightDateApproved = 'order.flight_date_approved',
}
